import {
    CREATE_GARMENTS_PO_INWARD_MASTER_REQUEST,
    CREATE_GARMENTS_PO_INWARD_MASTER_SUCCESS,
    CREATE_GARMENTS_PO_INWARD_MASTER_FAILURE,
    DELETE_GARMENTS_PO_INWARD_MASTER_REQUEST,
    DELETE_GARMENTS_PO_INWARD_MASTER_SUCCESS,
    DELETE_GARMENTS_PO_INWARD_MASTER_FAILURE,
    FETCH_SINGLE_GARMENTS_PO_INWARD_MASTER_REQUEST,
    FETCH_SINGLE_GARMENTS_PO_INWARD_MASTER_SUCCESS,
    FETCH_SINGLE_GARMENTS_PO_INWARD_MASTER_FAILURE,
    FETCH_GARMENTS_PO_INWARD_MASTER_REQUEST,
    FETCH_GARMENTS_PO_INWARD_MASTER_SUCCESS,
    FETCH_GARMENTS_PO_INWARD_MASTER_FAILURE,
    UPDATE_GARMENTS_PO_INWARD_MASTER_REQUEST,
    UPDATE_GARMENTS_PO_INWARD_MASTER_SUCCESS,
    UPDATE_GARMENTS_PO_INWARD_MASTER_FAILURE,
    RESET_GARMENTS_PO_INWARD_MASTER_INFO,
    CREATE_GARMENTS_PO_INWARD_MASTER_FORM,
    UPDATE_GARMENTS_PO_INWARD_MASTER_FORM,
    NAVIGATE_GARMENTS_PO_INWARD_DETAILS,
    NAVIGATE_GARMENTS_PO_INWARD_MASTER,
    FETCH_PENDING_GARMENTS_PO_IN_INWARD_REQUEST,
    FETCH_PENDING_GARMENTS_PO_IN_INWARD_SUCCESS,
    FETCH_PENDING_GARMENTS_PO_IN_INWARD_FAILURE,
    RESET_FORM_DATA_WITHOUT_GARMENTS_INWARD_ID,
    SET_ACTIVE_KEY_GARMENTS_INWARD,
    SET_END_DATE_GARMENTS_PO_INWARD,
    SET_START_DATE_GARMENTS_PO_INWARD,
    SET_UNIT_NAME_GARMENTS_PO_INWARD
} from './garmentsPoInwardHeader.actionsType';

export const GARMENTS_PO_INWARD_MASTER = 'garmentsPoInwardHeader';

let initialState = {
    loading: false,
    cuttingDcInwardHeader: [],
    pendingCuttingInward: [],
    activeKey: 1,
    garmentsInwardId: '',
    garmentsPoInwardHeaderForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null
    },
    selectedState: {},
    typeOfPoList: [],
    sourceList: [],
    departmentList: [],
    deliveryAt: [],
    errorMessage: '',
    singleGarmentsPOInwardData: {},
    isCuttingDcInwardDetails: false,
    goBack: true,
    unitId: '',
    startDate: new Date().setDate(new Date().getDate() - 15),
    endDate: new Date(),

};

export let garmentsPoInwardHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_GARMENTS_PO_INWARD_MASTER_REQUEST:
        case FETCH_PENDING_GARMENTS_PO_IN_INWARD_REQUEST:
        case CREATE_GARMENTS_PO_INWARD_MASTER_REQUEST:
        case UPDATE_GARMENTS_PO_INWARD_MASTER_REQUEST:
        case FETCH_SINGLE_GARMENTS_PO_INWARD_MASTER_REQUEST:
        case DELETE_GARMENTS_PO_INWARD_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_GARMENTS_PO_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDcInwardHeader: updatePayload
            };
        case FETCH_PENDING_GARMENTS_PO_IN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingCuttingInward: updatePayload
            };
        case CREATE_GARMENTS_PO_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPoInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null
                },
                garmentsInwardId: updatePayload[0],
                activeKey: updatePayload[0]?.fldID ? 2 : 1
            };
        case UPDATE_GARMENTS_PO_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPoInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null
                }
            };
        case FETCH_SINGLE_GARMENTS_PO_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPoInwardHeaderForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case DELETE_GARMENTS_PO_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                garmentsPoInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null
                }
            };
        case SET_ACTIVE_KEY_GARMENTS_INWARD:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case RESET_GARMENTS_PO_INWARD_MASTER_INFO:
            return {
                ...state,
                garmentsPoInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null
                },
                garmentsInwardId: '',
                activeKey: 1
            };
        case RESET_FORM_DATA_WITHOUT_GARMENTS_INWARD_ID:
            return {
                ...state,
                garmentsPoInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null
                },
                selectedTeam: {}
            };
        case CREATE_GARMENTS_PO_INWARD_MASTER_FORM:
        case UPDATE_GARMENTS_PO_INWARD_MASTER_FORM:
            return {
                ...state,
                loading: false,
                garmentsPoInwardHeaderForm: {
                    ...state.garmentsPoInwardHeaderForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_GARMENTS_PO_INWARD_MASTER_FAILURE:
        case FETCH_PENDING_GARMENTS_PO_IN_INWARD_FAILURE:
        case CREATE_GARMENTS_PO_INWARD_MASTER_FAILURE:
        case UPDATE_GARMENTS_PO_INWARD_MASTER_FAILURE:
        case FETCH_SINGLE_GARMENTS_PO_INWARD_MASTER_FAILURE:
        case DELETE_GARMENTS_PO_INWARD_MASTER_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_GARMENTS_PO_INWARD_DETAILS:
            return {
                ...state,
                isCuttingDcInwardDetails: true,
                singleGarmentsPOInwardData: updatePayload.singleGarmentsPOInwardData
            };
        case NAVIGATE_GARMENTS_PO_INWARD_MASTER:
            return {
                ...state,
                isCuttingDcInwardDetails: false,
                goBack: false
            };
        case SET_UNIT_NAME_GARMENTS_PO_INWARD:
            return {
                ...state,
                unitId: payload
            };
        case SET_START_DATE_GARMENTS_PO_INWARD:
            return {
                ...state,
                startDate: payload
            };
        case SET_END_DATE_GARMENTS_PO_INWARD:
            return {
                ...state,
                endDate: payload
            };
        default:
            return state;
    }
};
